<script>
import Layout from "../../layouts/frontend.vue";
import { customizerMethods, customizerComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import router from "@/router";
import Swal from "sweetalert2";
export default {
  page: {
    title: "Order Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      dataLoaded: false,
      isSaveable: false,
      defaultImage: require("@/assets/images/placeholder.webp"),
      defaultLogo: require("@/assets/images/brickbin-logo.png"),
    };
  },
  components: {
    Layout,
  },
  methods: {
    ...customizerMethods,
    async configurePrintArea(print_area, currentOrderItem) {
      let thisInstance = this;
      try {
        await thisInstance.setPrintArea(print_area);
        await thisInstance.setCurrentOrderItem(currentOrderItem);
        router.push({ name: "customize-item" });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "An error occured",
          text: JSON.stringify(error),
        });
      }
    },
    allPrintAreasCustomized() {
      if (this.customerDesigns.length == 0) {
        this.isSaveable = false;
        return;
      }

      let totalPrintsAreas = 0;
      let customized = 0;
      this.orderItems.forEach((orderItem) => {
        if (orderItem.product.print_areas) {
          orderItem.product.print_areas.forEach((printArea) => {
            totalPrintsAreas++;
            if (this.isPrintAreaCustomized(printArea, orderItem)) {
              customized++;
            }
          });
        }
      });
      this.isSaveable = totalPrintsAreas == customized ? true : false;
    },
    doesPrintAreaHasDesign(printArea, orderItem) {
      let status = false;
      if (printArea && orderItem && this.customerDesigns && this.customerDesigns.length) {
        this.customerDesigns.forEach(function (design) {
          if (printArea.id == design.printAreaId && orderItem.id == design.orderItemId) {
            status = true;
          }
        });
      }
      return status;
    },
    isMainDesign(printArea, orderItem) {
      let status = false;
      if (printArea && orderItem && this.customerDesigns && this.customerDesigns.length) {
        this.customerDesigns.forEach((design) => {
          if (printArea.id == design.printAreaId && orderItem.id == design.orderItemId) {
            if (design.useSameDesign == true) {
              status = true;
            }
          }
        });
      }
      return status;
    },
    isUsingSameDesign(printArea, orderItem) {
      let status = false;
      if (printArea && orderItem && this.customerDesigns && this.customerDesigns.length) {

        let useSameDesignSelected = false;

        this.customerDesigns.forEach((design) => {
          if (orderItem.id == design.orderItemId) {
            if (useSameDesignSelected == false && design.useSameDesign == true) {
              useSameDesignSelected = true;
            }
          }
        });


        if (useSameDesignSelected) {
          status = true;
        }

      }
      return status;
    },
    isPrintAreaCustomized(printArea, orderItem) {
      let status = false;
      if (printArea && orderItem && this.customerDesigns && this.customerDesigns.length) {

        if (this.isUsingSameDesign(printArea, orderItem) || this.doesPrintAreaHasDesign(printArea, orderItem)) {
          status = true;
        }

      }
      return status;
    },
    isPrintAreaCustomizable(printArea, orderItem) {
      let status = false;
      if (!this.customerDesigns) {
        return true;
      }
      if (printArea && orderItem) {
        if (this.isMainDesign(printArea, orderItem) || !this.isUsingSameDesign(printArea, orderItem)) {
          status = true;
        }
      }
      return status;
    },
    saveCustomizedOrder() {
      let thisInstance = this;
      Swal.fire({
        icon: "info",
        title: "Save Order?",
        text: 'Please make sure you have configured all of your order items properly before submitting your designs it may not be possible to make changes after confirming',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        customClass: {
          confirmButton: 'btn btn-success',
          denyButton: 'btn btn-danger'
        }
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          thisInstance.pushOrderDataToBackend();
        }
      });
    },
    pushOrderDataToBackend() {
      Swal.fire({
        icon: "info",
        title: "Submitting",
        text: 'Please wait while we submit your designs',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showDenyButton: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      let orderData = {};
      orderData.order_id = this.order.id;
      orderData.customer_design = this.customerDesigns;
      this.updateCustomerOrder(orderData)
        .then(
          function () {
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Designs Submitted",
            });
          },
          function (error) {
            Swal.close();
            Swal.fire({
              icon: "error",
              title: "An error occurred",
              text: JSON.stringify(error),
            });
          }
        );
    },
    getImagePath(file) {
      if (!file) {
        return false;
      }
      if (file.constructor.name === "File") {
        return URL.createObjectURL(file);
      }
      return this.resolveImagePath(file);
    },
  },
  computed: {
    ...customizerComputed,
  },
  mounted() {
    if (this.$route.params.token) {
      let thisInstance = this;
      this.loginWithSSO(this.$route.params.token)
        .then(
          function () {
            thisInstance.dataLoaded = true;
          },
          function () {
            router.push({ name: "404" });
          }
        )
        .catch(function (error) {
          console.log(error);
          router.push({ name: "404" });
        });
    } else {
      router.push({ name: "404" });
    }
    this.allPrintAreasCustomized();
  },
};
</script>

<template>
  <Layout>

    <!-- Order details modal -->
    <b-modal id="order-details" title="Order Details" :hide-footer="true" size="xl" centered>
      <div class="card mb-0 flex-grow-1">
          <div class="card-body">
            <div class="row">

              <div class="col-12 col-lg-4">
                <table class="table">
                  <tbody>
                    <tr>
                      <td colspan="2" class="pt-0">
                        <h5>Basic Details:</h5>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Order ID</th>
                      <td>{{ order.id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Order Date</th>
                      <td>{{ moment(order.created_at).format("YYYY-MM-DD") }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Order Status</th>
                      <td>{{ order.status.name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Order Origin</th>
                      <td>{{ order.origin.name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Last Updated</th>
                      <td>{{ moment(order.created_at).format("YYYY-MM-DD") }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div class="col-12 col-lg-8">
                <table class="table">
                  <tbody>
                    <tr>
                      <td colspan="2" class="pt-0">
                        <h5>Customer Details:</h5>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Email</th>
                      <td>{{ customer.email }}</td>
                    </tr>
                    <tr>
                      <th scope="row">First Name</th>
                      <td>{{ customer.first_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Last Name</th>
                      <td>{{ customer.last_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Phone</th>
                      <td>{{ customer.phone }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Company</th>
                      <td>{{ customer.company }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Address 1</th>
                      <td>{{ customer.address_1 }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Address 2</th>
                      <td>{{ customer.address_2 }}</td>
                    </tr>
                    <tr>
                      <th scope="row">State</th>
                      <td>{{ customer.state }}</td>
                    </tr>
                    <tr>
                      <th scope="row">City</th>
                      <td>{{ customer.city }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Postcode</th>
                      <td>{{ customer.postcode }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </b-modal>
    <!-- Order details modal -->

    <div
      class="
        text-center
        d-flex
        align-items-center
        justify-content-center
        vh-100
        w-100
      "
      v-if="!dataLoaded"
    >
      <b-spinner variant="primary"></b-spinner>
    </div>

    <div class="container-fluid p-5 pt-4 d-flex flex-column flex-grow-1" v-else>
      <div class="row mb-3 d-flex align-items-center">
        <div class="col-2">
          <b-img :src="getImagePath(order.origin.image) || defaultLogo" :alt="order.origin.name" fluid style="width: 100px">        
          </b-img>
        </div>
        <div class="col-10 text-end">
          <b-button  v-b-modal.order-details>Order Details</b-button>
        </div>
      </div>
      <div class="row d-flex align-items-stretch flex-grow-1">
        <div class="col d-flex flex-column">
          <div class="card mb-0 flex-grow-1">
            <div class="card-body d-flex flex-column">
              <div class="pb-4 text-center">
                <h2>Order Items:</h2>
                <p v-if="order.status.id == 1 || order.status.id == 4">Please press the configure button bellow to design the products within your order.</p>
              </div>
              <div class="container flex-grow-1">
                <div class="row d-flex">
                  <div class="col-12 col-lg-3" v-for="(item) in orderItems" :key="item.id">
                    <div v-if="item.product">
                      <h4 class="text-center py-2">{{ item.product.name }}</h4>
                      <b-img :src="getImagePath(item.product.image) || defaultImage" :alt="item.product.name" fluid thumbnail>        
                      </b-img>
                      <div class="d-flex flex-column pt-2" v-if="item.product && item.product.print_areas">
                        <div class="p-2 border rounded mb-1 d-flex align-items-center flex-row" v-for="print_area in item.product.print_areas" :key="print_area.id">
                          <span class="flex-grow-1">{{ print_area.name }}</span>
                          <b-button
                              v-if="order.status.id == 1 || order.status.id == 4
                                "
                              @click="configurePrintArea(print_area, item)"
                              size="sm"
                              :disabled="isPrintAreaCustomizable(print_area, item) == false"
                            >
                              <span v-if="isPrintAreaCustomized(print_area, item)">Configured</span>
                              <span v-else>Configure</span>
                            </b-button>
                            <span
                              v-else
                              class="
                                p-2
                                py-1
                                d-inline-block
                                border
                                rounded
                              "
                            >
                              Configured
                            </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>No product data available</span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center border-top p-4">
                <p class="text-center" v-if="[2, 3, 5, 6].includes(order.status.id)">Your order has already been designed and further changes may not be possible<br/>if you feel a mistake has been made please ring us on 01274062862</p>
                <p v-if="order.status.id == 1 || order.status.id == 4">Finished with your designs? Save and submit your order by clicking the button below.</p>
                <b-button
                  v-if="order.status.id == 1 || order.status.id == 4"
                  @click="saveCustomizedOrder"
                  :disabled="!isSaveable"
                  size="lg"
                  variant="success"
                >
                  <span>Save and submit your images</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
    
<style scoped>
.well {
  height: 600px;
  position: relative;
}

.table-scroll tbody {
  position: absolute;
  left: 0;
  right: 0;
  overflow-y: auto;
  height: 600px;
}

.table-scroll tr {
  width: 100%;
  table-layout: fixed;
  display: inline-table;
}
</style>